import {useState, useEffect, useRef, useLayoutEffect} from "react";
import {useDataApi, API} from "../components/API/index";
import {decodeURLParams, objectToQueryParams} from "../utils/index";

const getConfig = (apiName, tsLogin) => {
    let width,
        height,
        clientId,
        redirectUri,
        stateParam,
        scope,
        responseType,
        url,
        authUrl,
        method;

    switch (apiName) {
        case "facebook":
            width = 600;
            height = 600;
            clientId = "140520749308595";
            redirectUri = window.location.origin + "/loader.html";
            stateParam = "";
            scope = "email";
            responseType = "code";
            url = `https://www.facebook.com/dialog/oauth?client_id=${clientId}&redirect_uri=${redirectUri}&state=${stateParam}&scope=${scope}&display=popup&response_type=${responseType}&apiName=${apiName}`;
            authUrl = tsLogin ? API.AUTH_TEAMSTATS : API.AUTH_FACEBOOK;
            method = "POST";
            break;
        case "google":
            width = 600;
            height = 600;
            clientId =
                "384711134328-f5lu99bd2a08ntqt3p1ksumjkhf3prpm.apps.googleusercontent.com";
            redirectUri = window.location.origin + "/loader.html";
            stateParam = "";
            scope = "openid profile email";
            responseType = "code";
            url = `https://accounts.google.com/o/oauth2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&state=${stateParam}&scope=${scope}&display=popup&response_type=${responseType}&apiName=${apiName}`;
            authUrl = tsLogin ? API.AUTH_TEAMSTATS : API.AUTH_GOOGLE;
            method = "POST";
            break;
        case "twitter":
            width = 600;
            height = 600;
            url = `${tsLogin ? API.AUTH_TEAMSTATS : API.AUTH_TWITTER}?apiName=${apiName}`;
            authUrl = tsLogin ? API.AUTH_TEAMSTATS : API.AUTH_TWITTER;
            method = "GET";
            break;
        default:
            break;
    }

    return {
        left: window.screenX + (window.outerWidth - width) / 2,
        top: window.screenY + (window.outerHeight - height) / 2.5,
        width,
        height,
        clientId,
        redirectUri,
        stateParam,
        scope,
        url,
        authUrl,
        method,
        apiName
    };
};

const useInterval = (callback, delay) => {
    const savedCallback = useRef();
    useEffect(() => {
        savedCallback.current = callback;
    });

    useEffect(() => {
        function tick() {
            savedCallback.current();
        }

        if (!delay) {
            return;
        }
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
    }, [delay]);
};

let config, popupDisplayOptions;

export default (initialApiName) => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const [apiName, setApiName] = useState(initialApiName);

    const [authParams, setAuthParams] = useState();

    const {data, isLoading, isError, doFetch} = useDataApi("");

    const popupWindow = useRef();

    useLayoutEffect(() => {
        if (!apiName) {
            return;
        }
        const _url = `${config.url}`;
        popupWindow.current = window.open(_url, "login", popupDisplayOptions);
        setIsPopupOpen(true);
        return () => {
        };
    }, [apiName]);

    useEffect(() => {
        if (authParams) {
            if (config.method === "POST") {
                doFetch(config.authUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({...authParams, ...config})
                }, {ignoreCache: true});
            } else if (config.method === "GET") {
                doFetch(`${config.authUrl}?${objectToQueryParams(authParams)}`, {ignoreCache: true});
            }
            setApiName(null);
        }
    }, [authParams]);

    const pollPopup = () => {
        try {
            if (
                popupWindow.current.document && popupWindow.current.document.domain === document.domain &&
                (popupWindow.current.location.search ||
                    popupWindow.current.location.hash)
            )
            {
                const auth = decodeURLParams(popupWindow.current.location.search);
                setAuthParams(Object.assign(auth, {apiName}));
                popupWindow.current.close();
            }else if (popupWindow.current.closed) {
                setApiName(null);
            }
        } catch (error) {
            console.error("error", error);
        }
        setIsPopupOpen(!popupWindow.current.closed);
    };

    useInterval(pollPopup, isPopupOpen ? 500 : 0);

    const socialLogin = (apiName, tsLogin) => {
        config = getConfig(apiName, tsLogin);
        popupDisplayOptions = `top=${config.top},left=${config.left},width=${
            config.width
        },height=${config.height},resizable,scrollbars=yes,status=0`;
        setApiName(apiName);
    };

    return {socialLogin, socialData: data, isSocialLoading: isLoading, isSocialError: isError};
};
